import { render, staticRenderFns } from "./AddShop.vue?vue&type=template&id=e5a6d292&scoped=true"
import script from "./AddShop.vue?vue&type=script&lang=ts"
export * from "./AddShop.vue?vue&type=script&lang=ts"
import style0 from "./AddShop.vue?vue&type=style&index=0&id=e5a6d292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a6d292",
  null
  
)

export default component.exports